import { FilterOption } from '../../_WMS/FilterComponent/types'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 2,
    key: 'ean13',
    label: 'EAN13',
    type: 'text'
  },
  {
    order: 3,
    key: 'productName',
    label: 'Nombre Producto',
    type: 'text'
  },
  {
    order: 4,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 5,
    key: 'productOriginId',
    label: 'Marca',
    type: 'precreated'
  },
  {
    order: 6,
    key: 'batchControl',
    label: 'Control Fefo',
    type: 'precreated'
  },
  {
    order: 7,
    key: 'isGreenSale',
    label: 'Con Venta en Verde',
    type: 'precreated'
  }
]
